import { Badge } from '@apps/web/components/ui/badge';
import { statusIntentBadgeClassName } from '@apps/web/components/ui/status_tokens';
import { cn } from '@apps/web/lib/utils';
import { type OrganizationConversationCaregiverStatus } from '@libraries/typescript/api_client';

type CaregiverStatusBadgeProps = {
    readonly status?: OrganizationConversationCaregiverStatus | null;
    readonly className?: string;
};

export function CaregiverStatusBadge({
    status,
    className,
}: CaregiverStatusBadgeProps) {
    if (!status || status.is_active) {
        return null;
    }

    return (
        <Badge
            variant="outline"
            className={cn(
                'shrink-0',
                statusIntentBadgeClassName('negative'),
                className,
            )}
        >
            {status.label}
        </Badge>
    );
}
